import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigates to the previous page
  };

  const handleGoHome = () => {
    navigate("/"); // Navigates to the home page
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <SoftBox
                pt={6}
                pb={6}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                <SoftTypography variant="h1" fontWeight="bold" color="error" gutterBottom>
                  403
                </SoftTypography>
                <SoftTypography variant="h4" fontWeight="medium" gutterBottom>
                  {/* Unauthorized Access */}
                  {t("lang.unauthorized")}
                </SoftTypography>
                <SoftTypography variant="body1" mb={4}>
                  {/* {`Sorry, you don't have permission to view this page.`} */}
                  {t("lang.unauthorized_text")}
                </SoftTypography>
                <SoftBox display="flex" gap={2} justifyContent="center">
                  <SoftButton variant="gradient" color="info" onClick={handleGoBack}>
                    {/* Go Back */}
                    {t("lang.actions.go_back")}
                  </SoftButton>
                  <SoftButton variant="outlined" color="dark" onClick={handleGoHome}>
                    {/* Go to Home */}
                    {t("lang.actions.go_home")}
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
};

export default Unauthorized;
